import { UserType } from "@ecologi/shared";
import { fetchFromAPI } from "./fetch-from-api";

/**
 * We need to be able to query for a profile which is either a standalone profile or one which is a subforest profile.
 * In the case of a subforest we need to supply both the parent and child profile username to the API.
 *
 * The profile data is fetched via REST API
 * @param _
 * @param {string} rootUsernameOrId - The standalone profile name or the parent profile name for a a subforest
 * @param {string} childUsernameOrId - The child profile (which must have rootUsernameOrId as the parent)
 * @param {number} treeLimit - sets a pagination style limit to the user.trees property
 */
export const getProfileByUsernameOrId = async (
  _,
  rootUsernameOrId: string,
  childUsernameOrId: string
): Promise<UserType> => {
  if (rootUsernameOrId && childUsernameOrId) {
    return fetchFromAPI(
      `/users/${rootUsernameOrId}/${childUsernameOrId}/profile`,
      { passthrough: "api" }
    );
  } else if (rootUsernameOrId) {
    return fetchFromAPI(`/users/${rootUsernameOrId}/profile`, {
      passthrough: "api",
    });
  }
};
